<template>
  <div class="webContent flex" style="z-index: auto" scroll>
    <div style="height:100%;overflow:auto">
    <div class="model-title">车型对比</div>

    <!-- <div style="width: 100%;min-height: 3rem;display: flex">
      <div style="width: 31%;" class="side">
        <div class="side-top">
          <div class="title">车型信息</div>
          <div class="check">
            <el-checkbox v-model="highLight"
              >高亮显示不同</el-checkbox
            >
          </div>
          <div class="check">
            <el-checkbox v-model="hideSame"
              >隐藏显示相同项</el-checkbox
            >
          </div>
        </div>

        <div class="item-li label-li" v-for="(v, i) in itemList" :key="i">
          <div :class="v.value === '_title' ? 'second-title' : 'side-row'">
              {{ v.label }}
          </div>
        </div>

      </div>

      <div style="flex: 1;overflow-x: auto;overflow-y: hidden; white-space: nowrap">
        <div 
          v-for="(v, i) in this.list" :key="i"
          style="width: 50%;display: inline-block;position: relative;"
        >
            <div>
              <div class="candelete2" v-if="v.carName">
                <div class="delete" @click="deleteCar(i)">
                  <img src="./images/delete.png" />
                </div>
                <div class="pic">
                  <img v-if="v.imageUrl" :src="v.imageUrl" class="showImg" />
                  <img v-else src="./images/add.png" class="defaultImg" />
                </div>
                <div class="name">{{ v.carName || "" }}</div>
                <div class="change-btn" @click="changeCar(i, v)">更换</div>
              </div>

              <div v-else class="canadd">
                <div class="pic">
                  <img src="./images/add.png" class="defaultImg" />
                </div>
                <div class="empty-name"></div>
                <div class="change-btn" @click="changeCar(i)">添加车型</div>
              </div>
            </div>

            <div class="item-li" v-for="(k, j) in itemList" :key="j">
                <div
                  :class="k.value === '_title' ? 'second-title' : 'side-row'"
                  :style="
                    k.value === '_title' ? `height:${k.height}px` : `border-left: 1px solid #d0d1d4;height:${k.height}px`
                  "
                >
                  <span v-if="k.value === '_title'" style="color: transparent"
                    >-</span
                  >
                  <span v-else>
                    <span
                      v-if="list[i]['carName']"
                      :style="
                        highLight && k.highLight ? 'color: #d5001c' : 'color: #333'
                      "
                    >
                      {{ list[i][k.value] || "-" }}
                    </span>
                    <span v-else>{{ "-" }}</span>
                  </span>
                </div>
            </div>

        </div>
      </div>
    </div> -->

    <div class="top-2">
      <div class="side">
        <div class="title" style="border-bottom: 0">车型信息</div>
        <div class="check">
          <el-checkbox v-model="highLight"
            >高亮显示不同</el-checkbox
          >
        </div>
        <div class="check">
          <el-checkbox v-model="hideSame"
            >隐藏显示相同项</el-checkbox
          >
        </div>
      </div>

      <div class="car" v-for="(v, i) in list" :key="i" style="display: inline-block;position: relative;">
        <div class="candelete2" v-if="v.carName">
          <div class="delete" @click="deleteCar(i)">
            <img src="./images/delete.png" />
          </div>
          <div class="pic">
            <img v-if="v.imageUrl" :src="v.imageUrl" class="showImg" />
            <img v-else src="./images/add.png" class="defaultImg" />
          </div>
          <div class="name">{{ v.carName || "" }}</div>
          <div class="change-btn" @click="changeCar(i, v)">更换</div>
        </div>

        <div v-else class="canadd">
          <div class="pic">
            <img src="./images/add.png" class="defaultImg" />
          </div>
          <div class="empty-name">{{ "" }}</div>
          <div class="change-btn" @click="changeCar(i)">添加车型</div>
        </div>
      </div>
    </div>

    <div class="content" style="padding: 0">
      <div class="item-box">

        <div class="item-li" v-for="(v, i) in itemList" :key="i">
          <div
            v-if="v.hidden ? false : hideSame && v.hiddenSame ? false : true"
            style="display: flex"
          >
            <div :class="v.value === '_title' ? 'second-title' : 'side-row'">
              {{ v.label }}
            </div>

            <div
              :class="v.value === '_title' ? 'second-title' : 'side-row'"
              :style="
                v.value === '_title' ? '' : 'border-left: 1px solid #d0d1d4'
              "
            >
              <span v-if="v.value === '_title'" style="color: transparent"
                >-</span
              >
              <span v-else>
                <span
                  v-if="list[0]['carName']"
                  :style="
                    highLight && v.highLight ? 'color: #d5001c' : 'color: #333'
                  "
                >
                  {{ list[0][v.value] || "-" }}
                </span>
                <span v-else>{{ "-" }}</span>
              </span>
            </div>

            <div
              :class="v.value === '_title' ? 'second-title' : 'side-row'"
              :style="
                v.value === '_title' ? '' : 'border-left: 1px solid #d0d1d4'
              "
            >
              <span v-if="v.value === '_title'" style="color: transparent"
                >-</span
              >
              <span v-else>
                <span
                  v-if="list[1]['carName']"
                  :style="
                    highLight && v.highLight ? 'color: #d5001c' : 'color: #333'
                  "
                >
                  {{ list[1][v.value] || "-" }}
                </span>
                <span v-else>{{ "-" }}</span>
              </span>
            </div>

            <div
              :class="v.value === '_title' ? 'second-title' : 'side-row'"
              :style="
                v.value === '_title' ? '' : 'border-left: 1px solid #d0d1d4'
              "
            >
              <span v-if="v.value === '_title'" style="color: transparent"
                >-</span
              >
              <span v-else>
                <span
                  v-if="list[2]['carName']"
                  :style="
                    highLight && v.highLight ? 'color: #d5001c' : 'color: #333'
                  "
                >
                  {{ list[2][v.value] || "-" }}
                </span>
                <span v-else>{{ "-" }}</span>
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="foo-tip"> ※ 部分车型的标准配置或选装配置可能会被临时调整，敬请理解! </div>

    <!-- 选择大类 -->
		<div class="collectBase" v-if="isChangeParent">
			<div class="collectBase-box">
				<div class="collectBase-top">
					<div class="collectBase-close" @click="closeCollectBase"></div>
				</div>
				<div class="collectBase-list">
					<div class="collectBase-li df cf wao" 
            :class="{ cur: choose.includes(v.value) }"
						v-for="(v, i) in options" :key="i"
						@click="chooseCollectBase(v.value)">
						<div class="collectBase-title">{{v.label ? replace(v.label) : ''}}</div>
					</div>
				</div>
				<!-- <div class="collectBase-btn" @click="resCollectBase">确认</div> -->
			</div>
		</div>

    <!-- 选择子类 -->
		<div class="collectBase" v-if="isChangeSon">
			<div class="collectBase-box">
				<div class="collectBase-top">
					<div class="collectBase-close" @click="closeCollectBase2"></div>
				</div>
				<div class="collectBase-list">
					<div class="collectBase-li df cf wao" 
            :class="{ cur: choose.includes(v.value) }"
						v-for="(v, i) in modelList" :key="i"
						@click="chooseCollectBase2(v.value)">
						<div class="collectBase-title" >{{v.label ? replace(v.label) : ''}}</div>
					</div>
				</div>
				<div class="collectBase-btn" @click="resCollectBase2">确认</div>
			</div>
		</div>

    <!-- <el-dialog @close="closeEdit" :visible.sync="editVisible">
      <div>
        <el-cascader
          v-model="selectArr"
          :options="options"
          @change="handleChange"
        >
        </el-cascader>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="sureChange"
          style="background: #d5001c; border: 0"
          >确认</el-button
        >
        <el-button
          @click="closeEdit"
          style="background: #fff; border: 0; color: #000"
          >取消</el-button
        >
      </span>
    </el-dialog> -->
    </div>
  </div>
</template>

<script>
const initialItemList = () => [
  // 车身
  { label: "车身", value: "_title" },

  { label: "长(mm)", value: "length" },
  { label: "宽(包括/不包括后视镜)(mm)", value: "width" },
  { label: "高(mm)", value: "height" },
  { label: "轴距(mm)", value: "wheelbase" },
  { label: "行李箱容积(L)", value: "luggageVolume" },
  { label: "油箱容积(L)", value: "oilTankVolume" },
  { label: "空载重量(中国)(kg)", value: "emptyWeight" },
  // 动力传动
  { label: "动力传动", value: "_title" },

  { label: "发动机型式", value: "engineType" },
  { label: "进气型式", value: "intakeType" },
  { label: "排量(cm³)", value: "displacement" },
  { label: "最大功率(kW/PS)", value: "maxPower" },
  { label: "最大扭距(Nm)", value: "maxTorque" },
  { label: "发动机最高转速(rpm)", value: "maxRotateSpeed" },
  { label: "电动机最大功率(kW/PS)", value: "maxMotorPower" },
  { label: "电动机最大扭矩(Nm)", value: "maxMotorTorque" },
  {
    label: "搭配起步控制超级增压最大功率(Kw/PS)",
    value: "maxSuperChargingPower",
  },
  { label: "总系统最大功率(kW/PS)", value: "maxSystemPower" },
  { label: "总系统最大扭距(Nm)", value: "maxSystemTorque" },
  { label: "电池总容量(kWh)", value: "totalBatteryCapacity" },
  { label: "电池净容量(kWh)", value: "netBatteryCapacity" },
  { label: "CLTC续航里程(km)", value: "cltcRange" },
  { label: "驱动方式", value: "driveMode" },
  { label: "变速箱型式", value: "transmissionType" },
  // 性能
  { label: "性能", value: "_title" },

  { label: "不搭配/搭配SC组件0-100km/h加速时间(s)", value: "accelerationTime" },
  { label: "最高时速(km/h)", value: "topSpeed" },
  { label: "卡钳型式(前/后)", value: "caliperType" },
  { label: "制动盘尺寸(前/后)(mm)", value: "brakeDiscSize" },
  { label: "制动盘特征", value: "brakeDiscChar" },
  { label: "卡钳颜色", value: "caliperColor" },
  // 特殊数据
  { label: "特殊数据", value: "_title" },

  { label: "轮距(前后)", value: "wheelDistance" },
  { label: "最大离地间隙(mm)", value: "maxGroundClearance" },
  { label: "最大涉水深度(mm)", value: "maxWadingDepth" },
  { label: "接近角(度)", value: "approachAngleDegree" },
  { label: "离去角(度)", value: "departureAngleDegree" },
  { label: "通过角(度)", value: "throughAngleDegrees" },
  { label: "风阻系数", value: "dragCoefficient" },
  // 标准特征/配置
  { label: "标准特征/配置", value: "_title" },

  { label: "大灯系统", value: "lightSystem" },
  { label: "仪表/屏幕尺寸(英寸)", value: "screenWidth" },
  { label: "PCM屏幕尺寸(英寸)", value: "pcmScreenWidth" },
  { label: "座椅调节(向)", value: "frontSeatAdjustment" },
  { label: "音响系统", value: "audioSystem" },
  { label: "扬声器数量(个)", value: "speakersNum" },
  { label: "输出功率(W)", value: "outputPower" },
  { label: "车轮尺寸(英寸)", value: "wheelSize" },
  { label: "轮胎规格(前/后)", value: "tyreSpecific" },
  { label: "尾管数量/颜色", value: "tailpipesSpecific" },
  // 区别配置
  { label: "区别配置", value: "_title" },

  { label: "保时捷主动悬挂管理系统(PASM)", value: "pasm" },
  { label: "Sport Chrono组件", value: "sportChrono" },
  { label: "保时捷扭矩引导系统/升级版(PTV/PTV Plus)", value: "ptv" },
  { label: "带动力转向升级版的后桥转向系统", value: "rearAxleSteeringSystem" },
  { label: "自适应扰流板", value: "adaptiveSpoiler" },
  { label: "电动跑车声浪系统", value: "soundWaveSystem" },
  { label: "4区域自动恒温空调", value: "automaticAirConditioner" },
  { label: "座椅加热(前/后)", value: "seatHeating" },
  { label: "全景式天窗", value: "panoramicSunroof" },
  { label: "方向盘", value: "steeringWheel" },
  { label: "后侧车窗电动遮阳卷帘", value: "electricSunshadeRollerShutter" },
  { label: "环境氛围灯", value: "ambientAtmosphereLamp" },
  { label: "私密玻璃", value: "privacyGlass" },
  { label: "内饰组件", value: "interiorPackage" },
  { label: "车顶衬里", value: "roofLiner" },
  { label: "免钥匙进入系统", value: "keylessEntrySystem" },
  { label: "车门自动吸合", value: "automaticDoorClose" },
  { label: "倒车摄像头", value: "reversingCamera" },
  { label: "侧翼板/下帷幔", value: "sideWing" },
  { label: "侧车窗饰件", value: "sideWindowDecoration" },
  { label: "车门槛护板", value: "doorEntryGuard" },
  { label: "SportDesign前裙板", value: "frontApronSportDesign" },
  { label: "后视镜下部饰件/后视镜底座", value: "rearViewMirrorBase" },
  { label: "后扩散板镶嵌饰件", value: "rearDiffuserInlayDecoration" },
  { label: "尾门车型标记", value: "tailgateModelMark" },
  // 专属（独特）亮点配置
  { label: "专属（独特）亮点配置", value: "_title" },

  { label: "配置1", value: "config1" },
  { label: "配置2", value: "config2" },
  { label: "配置3", value: "config3" },
  { label: "配置4", value: "config4" },
  { label: "配置5", value: "config5" },
  { label: "配置6", value: "config6" },
  { label: "配置7", value: "config7" },
  { label: "配置8", value: "config8" },
  { label: "配置9", value: "config9" },
  { label: "配置10", value: "config10" },
];

export default {
  data() {
    return {
      highLight: true,
      hideSame: false,
      list: [
        {
          carName: "",
          length: "",
          width: "",
          height: "",
          engineType: "",
        },
        {
          carName: "",
          length: "",
          width: "",
          height: "",
          engineType: "",
        },
        {
          carName: "",
          length: "",
          width: "",
          height: "",
          engineType: "",
        },
      ],

      itemList: initialItemList(),

      editVisible: false,
      options: [],
      modelList: [],

      selectArr: [],
      changeIndex: "",

      isChangeParent: false,
      isChangeSon: false,
      choose: [],
    };
  },

  mounted() {
    // console.log(this.$refs.label.clientHeight)
    /* this.$nextTick(function () {
        this.itemList.map((v, i) => {
          v['height'] = document.getElementsByClassName("label-li")[i].clientHeight;
        })
    })
    console.log(this.itemList) */
    this.getCategory();
  },

  methods: {
    replace(input){
				return input.replace('<br/>','');
			},
    changeCar(i, item) {
      if (item) {
        this.choose = [item.categoryId, item.id];
      } else {
        this.choose = [];
      }
      this.changeIndex = i;
      // this.editVisible = true;
      this.isChangeParent = true
    },
    closeEdit() {
      this.editVisible = false;
    },
    getCategory() { // 车型大类
      this.h5Ajax("get", "$/carCategory/cascadeList", true).then((res) => {
        let arr = [];
        res &&
          res.map((v) => {
            let child = [];
            v.childList.map((k) => {
              child.push({
                label: k.carName,
                value: k.id,
              });
            });
            arr.push({
              label: v.carCategoryName,
              value: v.id,
              children: child,
            });
          });
        this.options = arr;
      });
    },
    handleChange(v) {
      this.selectArr = v;
    },

    chooseCollectBase(id){
        if(this.choose.length === 0){
					this.choose.push(id)
          const item = this.options.find( v => v.value === id)
          this.modelList = item.children
          this.isChangeParent = false;
          this.isChangeSon = true
          return
				}
        if(this.choose[0] !== id){
          this.choose.splice(0, 1, id)
          const item = this.options.find( v => v.value === id)
          this.modelList = item.children
          this.isChangeParent = false;
          this.isChangeSon = true
          return
        }
				if(this.choose[0] === id){
					this.choose = [];
          this.modelList = []
          return
				}
		},
    closeCollectBase(){
				this.isChangeParent = false;
				this.choose = []
		},
    resCollectBase(){
        if(!this.choose[0]){
          return
        }
				this.isChangeParent = false;
        this.isChangeSon = true
		},

    chooseCollectBase2(id){
        if(this.choose.length === 1){
					this.choose.push(id)
          return
				}
        if(this.choose[1] !== id){
          this.choose.splice(1, 1, id)
          return
        }
				if(this.choose[1] === id){
					this.choose.splice(1, 1);
          return
				}
        console.log(this.choose)
		},
    closeCollectBase2(){
				this.isChangeSon = false;
        this.isChangeParent = true;
				this.choose.splice(1, 1) ;
		},
    resCollectBase2(){
        // this.isChangeSon = false
        if(!this.choose[1]){
          return
        }
        this.sureChange()
		},


    deleteCar(i) {
      this.list.splice(i, 1, {
        carName: "",
        length: "",
        width: "",
        height: "",
        engineType: "",
      });
      
      let arr = []
      this.list.map( v => {
        if(v.carName){
            arr.push(v)
        }
      })
      if(arr.length === 0) this.itemList = initialItemList();
        else this.updateItemList();
      
    },

    updateItemList() {
      let arr = []
      this.list.map( v => {
        if(v.carName){
            arr.push(v.carName)
        }
      })

      const [one, two, three] = this.list;

      const displayPropertyMap = {};

      this.itemList.forEach(({ value: key }) => {
        if (key.startsWith("_")) {
          return;
        }

        const items = [one[key], two[key], three[key]];
        // console.log(items)

        const haveValItems = items.filter(Boolean);
        // console.log(haveValItems)

        const highLight =
          (haveValItems.length > 1 && [...new Set(haveValItems)].length > 1) || (arr.length > 1 && haveValItems.length === 1);

        const hiddenSame =
          haveValItems.length > 1 && [...new Set(haveValItems)].length === 1;

        displayPropertyMap[key] = {
          highLight,
          hiddenSame,
          hidden: !haveValItems.length,
        };
      });

      this.itemList = this.itemList.map((it) => {
        return {
          ...it,
          hidden: (displayPropertyMap[it.value] || { hidden: false }).hidden,
          highLight: (displayPropertyMap[it.value] || {}).highLight,
          hiddenSame: (displayPropertyMap[it.value] || {}).hiddenSame,
        };
      });
    },

    sureChange() {
      // 确认选择
      if (this.choose.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择对比车型！",
          type: "warning",
        });
        return;
      }
      let childId = this.choose[1];
      this.h5Ajax("post", `$/carInfo/find`, { id: childId }, true).then(
        (res) => {
          this.list[this.changeIndex] = JSON.parse(JSON.stringify(res));
          this.updateItemList();

        //   console.log(this.list, "---this.list---");
          this.choose = [];
          this.isChangeSon = false;

        }
      );
    },

  },

};
</script>

<style>
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #000 !important;
  border-color: #000 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #000 !important;
}
</style>

<style lang="scss" scoped>
@import './index.css';
/deep/ .el-checkbox__label{
  padding-left: 0 !important;
  font-size: .11rem;
  padding-left: .1rem;
}

.foo-tip{
  color: #000;
  line-height: .2rem;
  font-size: .11rem;
}

.model-title {
  line-height: .42rem;
  font-size: .2rem;
  font-weight: bold;
  color: #fff;
  border-left: .05rem solid #d5001c;
  text-indent: .10rem;
  background: url("./images/pic.jpg") no-repeat;
}

  .side{
    height: 1rem;
    background: #f5f6f8;
    border-bottom: .06rem solid #d5001c;
    .side-top{
      height: 0.95rem;
      .title {
        font-size: .15rem;
        font-weight: 500;
        color: #000;
        margin: .05rem 0 .05rem .05rem;
      }
      .check {
        margin-left: .05rem;
      }
    }

  }

  .canadd{
    width: 100%;
    height: 1rem;
    border-bottom: .06rem solid #d5001c;
  }
  .candelete2 {
    width: 100%;
    height: 1rem;
    border-top: .01rem solid #d5001c;
    border-left: .01rem solid #d5001c;
    border-right: .01rem solid #d5001c;
    border-bottom: .06rem solid #d5001c;
  }
  .delete {
    width: .3rem;
    height: .3rem;
    position: absolute;
    right: 0;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .pic {
    width: .68rem;
    height: .36rem;
    margin: 0 auto 0;
    overflow: hidden;
    .showImg {
      height: 100%;
      width: 100%;
    }
    .defaultImg{
      width: .38rem;
      height: .25rem;
      margin: .05rem auto;
      display: block;
    }

  }
  .name {
    color: #000;
    text-align: center;
    font-size: .11rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .empty-name{
    margin-bottom: .1rem;
  }
  .change-btn {
    margin: 0 auto;
    width: .55rem;
    height: .24rem;
    border: 1px solid #000;
    border-radius: .02rem;
    line-height: .24rem;
    text-align: center;
    cursor: pointer;
    font-size: .11rem;
  }

.second-title {
    line-height: .2rem;
    padding: .08rem .1rem;
    background-color: #e0e1e3;
    width: 100%;
}


.top-2{
  display: flex;
  .side{
    width: 25%;
    display: inline-block;
    overflow: hidden;
    .title {
      font-size: .15rem;
      font-weight: 500;
      color: #000;
      margin: .05rem 0 .05rem 0rem;
    }
  }
  .car{
    width: 25%;
    display: inline-block;
  }
}

.item-li {
  // v2
  width: 100%;
  .side-row {
    width: 100%;
    line-height: .2rem;
    padding: .08rem .10rem;
    border-bottom: .01rem solid #d0d1d4;
    background: #f8f8f9;
    color: #333333;
  }
}


.content {
  width: 100%;
  min-height: 300px;
  border-left: 1px solid #d0d1d3;
  border-right: 1px solid #d0d1d3;
  
}
</style>


// WEBPACK FOOTER //
// src/app/pages/home/carCompare/index.vue